import { render, staticRenderFns } from "./switchcore.vue?vue&type=template&id=14a63c64&scoped=true&"
import script from "./switchcore.vue?vue&type=script&lang=js&"
export * from "./switchcore.vue?vue&type=script&lang=js&"
import style0 from "./switchcore.vue?vue&type=style&index=0&id=14a63c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a63c64",
  null
  
)

export default component.exports